import React from 'react';
import Select from 'react-select';

const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: '2-digit' });
};

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const selectStyles = {
  container: (base) => ({ ...base, minWidth: 150, fontSize: 14 }),
  control: (base, state) => ({
    ...base,
    minHeight: 36,
    flexDirection: 'row-reverse',
    gap: 6,
    borderRadius: 8,
    backgroundColor: 'var(--sl-bg-primary)',
    borderColor: state.isFocused ? 'var(--sl-border-brand)' : 'var(--sl-border-primary)',
    boxShadow: 'var(--sl-shadow-xs)',
    cursor: 'pointer',
    ':hover': { borderColor: 'var(--sl-border-brand)' },
  }),
  valueContainer: (base) => ({ ...base, padding: '0 4px 0 12px' }),
  placeholder: (base) => ({ ...base, color: 'var(--sl-text-primary)', fontWeight: 600, whiteSpace: 'nowrap' }),
  input: (base) => ({ ...base, color: 'var(--sl-text-primary)' }),
  dropdownIndicator: (base) => ({ ...base, padding: '0 0 0 12px', color: 'var(--sl-text-primary)' }),
  indicatorSeparator: () => ({ display: 'none' }),
  menuPortal: (base) => {
    const menuWidth = 320;
    const shift = (base.width || 0) - menuWidth;
    return { ...base, zIndex: 9999, width: menuWidth, left: Math.max(8, (base.left || 0) + shift) };
  },
  menu: (base) => ({
    ...base,
    width: 320,
    backgroundColor: 'var(--sl-bg-primary)',
    border: '1px solid var(--sl-border-secondary)',
    boxShadow: 'var(--sl-shadow-lg)',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? 'var(--sl-bg-secondary)' : 'transparent',
    color: 'var(--sl-text-primary)',
    cursor: 'pointer',
    ':active': { backgroundColor: 'var(--sl-bg-active)' },
  }),
  noOptionsMessage: (base) => ({ ...base, color: 'var(--sl-text-tertiary)' }),
};

const renderOption = (option) => (
  <div className="mi-ce-add-option">
    <span>{option.name}</span>
    {option.date && <span className="mi-ce-add-option-date">{option.date}</span>}
  </div>
);

const ComparableEventsEditor = ({ availableEvents, onAdd, busy, autoFocus }) => {
  const options = (availableEvents || []).map((e) => {
    const date = formatDate(e.event_date);
    return {
      value: e.id,
      name: e.name,
      date,
      label: date ? `${e.name} ${date}` : e.name,
    };
  });

  return (
    <Select
      options={options}
      value={null}
      onChange={(option) => { if (option) onAdd(option.value); }}
      isDisabled={busy || options.length === 0}
      isClearable={false}
      controlShouldRenderValue={false}
      formatOptionLabel={renderOption}
      placeholder={options.length === 0 ? 'No more events to add' : 'Add event'}
      components={{ DropdownIndicator: PlusIcon }}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      styles={selectStyles}
      classNamePrefix="mi-ce-add"
      aria-label="Add a comparable event"
      autoFocus={autoFocus}
      openMenuOnFocus={autoFocus}
    />
  );
};

export default ComparableEventsEditor;
